import Basket from './basket.svg';
import Chrono from './chrono.svg';
import CrossRedCircle from './cross-red-circle.svg';
import CrossWhite from './cross-white.svg';
import DartyComLogo from './darty-com-logo.svg';
import DartyProLogo from './darty-pro-logo.svg';
import GreenCheck from './green-check.svg';
import Kitchen from './kitchen.svg';
import Lock from './lock.svg';
import Location from './location.svg';
import Paypal from './paypal.svg';
import Pencil from './pencil.svg';
import QuestionMarkGrey from './question-mark-grey.svg';
import SpinnerBlue from './spinner-blue.svg';
import SpinnerWhite from './spinner-white.svg';

export const Icons: { [index: string]: string } = {
  Basket,
  Chrono,
  CrossRedCircle,
  CrossWhite,
  DartyComLogo,
  DartyProLogo,
  GreenCheck,
  Kitchen,
  Location,
  Lock,
  Paypal,
  Pencil,
  QuestionMarkGrey,
  SpinnerBlue,
  SpinnerWhite,
};
